import { Box, useTheme } from "@mui/material";
import siteImages from "../../data/siteImages";

const Logo = ({ variant }: { variant: "header" | "footer" }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: { xs: theme.spacing(18), lg: theme.spacing(25) },
        mx: variant === "header" ? 4 : 0
      }}>
      <img style={{ width: "inherit" }} src={siteImages.logo.src} alt={siteImages.logo.alt} />
    </Box>
  );
};

export default Logo;
